import { FIT_TO_WIDTH_OFF, FIT_TO_WIDTH_ON } from '../actions/types';

export default function stayFitToWidth(state = false, action = {}) {
  switch (action.type) {
    case FIT_TO_WIDTH_OFF:
      return false;
    case FIT_TO_WIDTH_ON:
      return true;
    default:
      return state;
  }
}
